const parallaxSection = ({ el }) => {
   const innerContent = el.querySelector('[data-parallax-inner]');
   const contentHeight = innerContent.offsetHeight;
   const header = document.querySelector('[data-header]');
   const headerHeight = header.offsetHeight;
   const screenHeight = window.innerHeight - headerHeight;

   const prevElement = el.previousElementSibling;
   const nextElement = el.nextElementSibling;
   let containerClass = "";

   const bothClassName = 'parallax__container--both';
   const bottomClassName = 'parallax__container--bottom';
   const topClassName = 'parallax__container--top';

   const sectionParallaxBottom = () => {
      if (el.hasAttribute('data-parallax-triple')) {
         el.style.height = `${contentHeight + screenHeight + screenHeight}px`;
      } else {
         el.style.height = `${contentHeight + screenHeight}px`;
      }
      const topOffset = contentHeight - screenHeight - headerHeight;
      if (topOffset > 0) {
         innerContent.style.top = `-${topOffset}px`;
      } else if ((topOffset * -1) < headerHeight) {
         innerContent.style.top = `${topOffset * -1}px`;
      } else {
         innerContent.style.top = `${headerHeight}px`;
      }
   }

   if (prevElement.hasAttribute('data-parallax')) {
      let runExtraHeightCode = false;
      if (nextElement.hasAttribute('data-parallax')) {
         containerClass = bothClassName;
         sectionParallaxBottom();
      } else {
         containerClass = topClassName;
         runExtraHeightCode = true;
      }
      const prevElementInnerHeight = prevElement.querySelector('[data-parallax-inner]').offsetHeight;
      if (prevElementInnerHeight < screenHeight) {
         const marginValue = (screenHeight * 2) + headerHeight - prevElementInnerHeight;
         el.style.marginTop = `-${marginValue}px`;
         if (runExtraHeightCode) {
            el.style.height = `${marginValue}px`;
         }
      }
   } else if (nextElement.hasAttribute('data-parallax')) {
      containerClass = bottomClassName;
      sectionParallaxBottom();
   }

   if (containerClass) {
      el.classList.add(containerClass);
   }

   if (prevElement.hasAttribute('data-parallax-triple')) {
      el.style.marginTop = `-${(screenHeight * 2) - headerHeight}px`;
   }

}

export default parallaxSection;